<template>
  <!--    :style="{ backgroundImage: 'url(&quot;' + category.image + '&quot;)'}"-->
  <div class="box"
       :class="btnClasses">
    <div class="boxInner">

      <div class="img" v-if="theImage"
           :class="{isKiosk: $store.getters.isKiosk}"
           :style="{ backgroundImage: 'url(&quot;' + theImage + '&quot;)'}"></div>

      <!--    <div class="text-center pt-4 pb-1" v-if="icon">-->
      <!--      <v-icon dark x-large class="myAccent">{{ 'mdi-' + icon }}</v-icon>-->
      <!--    </div>-->

      <div class="text-center mt-3" v-if="anyIcon">
        <v-icon v-if="icon" dark class="myWhite buttonIcon iconSpace">{{ '' + icon }}</v-icon>
        <img v-if="svg" class="imgIcon iconSpace" :src="svgSource"/>
        <img v-if="pngicon" class="imgIcon iconSpace" :src="pngSource" :class="{soloInvert: inverse}"/>
        <img v-if="rastericon" class="imgIcon iconSpace" :src="rasterSource"/>
      </div>
      <div class="bottom d-flex align-center" :class="{center: anyIcon}">
        <h3 class="flex-grow-1 mobile customPadding titleFont"
            :class="{oneLiner: nomargin && $store.getters.deviceClass.includes('xs')}">{{ theLabel }}</h3>
        <h3 class="flex-grow-1 tablet text-truncate customPadding titleFont">{{ theLabel }}</h3>
        <div class="text-right align-self-center" v-if="!anyIcon">
          <v-icon class="myAccent">mdi-chevron-right</v-icon>
        </div>
      </div>
      <div class="mb-1" v-if="anyIcon"></div>
      <!--        <div class="bottom">-->


      <!--            <div class="s">Description</div>-->
      <!--        </div>-->
    </div>
  </div>
</template>

<script>
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants';

export default {
  name: "CategoryCard",
  props: {
    bg: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'false'
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    pngicon: {
      type: String,
      default: null
    },
    rastericon: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    },
    svg: {
      type: String,
      default: null
    },
    nomargin: {
      type: Boolean,
      default: false
    },
    category: Object
  },
  data: () => ({
    theLabel: '',
    theImage: '',
  }),

  computed: {
    btnClasses() {
      // nomargin: nomargin, noImage: !theImage, withIcon: anyIcon
      let c = {
        nomargin: !!this.nomargin,
        noImage: !this.theImage,
        withIcon: !!this.anyIcon,
        defaultBgColor: !this.bg,
      };

      if (this.bg) {
        c['bg' + this.bg] = true;
        console.log('.bg' + this.bg);
      } else {
        c['defaultBgColor'] = true;
      }

      return c;
    },
    anyIcon() {
      return this.svg || this.icon || this.pngicon || this.rastericon;
    },
    svgSource() {
      let img = require(`@/assets/svg/${this.svg}.svg`);
      // '/assets/svg/' + this.svg + '.svg';
      return img;
    },
    pngSource() {
      let img = require(`@/assets/icons/${this.pngicon}.png`);
      // '/assets/svg/' + this.svg + '.svg';
      return img;
    },
    rasterSource() {
      let img = require(`@/assets/icons/${this.rastericon}`);
      // '/assets/svg/' + this.svg + '.svg';
      return img;
    },
  },

  created() {
    this.init();
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.theLabel = this.label;
      this.theImage = this.image;

      if (this.category && this.category.categoryDE) {
        this.theLabel = '' + this.category.categoryDE;
        this.theImage = this.category.image ? '' + this.category.image : '';
      } else {
        setTimeout(() => {
          //retry
          this.init();
        }, 1000);
      }
    }

  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';
@import '../styles/stempel';


.iconSpace {
  margin-bottom: -5px;
  margin-top: 3px;
}


$imgWidth: 1200;
$imgHeight: 800;


.buttonIcon {
  //height: 30px;
  //width: 30px;
  font-size: 30px;
}

.imgIcon {
  height: 30px;
  width: auto;
}

.customPadding {
  /*margin-top: 5px;*/
}

.boxInner {
  display: block;
  width: 100%;
}

.box {
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  max-width: 100%;
  margin: 7px 0;
  text-transform: uppercase;
  /*margin: 8px 0;*/
  /*height: 220px;*/
  overflow: hidden;
  /*position: relative;*/

  //background-color: transparent;
  //      border: 1px solid $color-primary;
  background-color: $color-primary;
  @include bgLinear;
  //background-color: $color-primary;

  &.bgStempelkarte {
    background-color: $stempelBgColor;
  }

  //@include material-shadow(1);
  &.noImage {
    border-radius: 100px;
    padding-left: 15px;
  }

  &.withIcon {
    padding-right: 15px;
    //border-radius: 25px;
  }

  &.nomargin {
    margin: 0;
  }

  h3 {
    @include text-contrast($color-primary);
    //color: white;
    text-transform: none;
  }

  border-radius: $box-border-radius;
  //border-radius: 2px;
  //border: 2px solid $accent;
  /*h3{*/
  /*    color: white;*/
  /*}*/
  //color: $font-color;

  /*background-color: gray;*/

  //border-radius: $box-border-radius;

  /*background-position: center;*/
  /*//background-position: 0 100%; //focused corner is bottom left*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/
  /*background-image: url('../assets/bg2.jpg');*/

  transition: all 0.4s ease;

  //@include material-shadow(1);

  &:hover {
    /*background-color: #bbb;*/
    background-color: $color-hover;

    h3 {
      //color: $font-color;
    }

    .img {
      filter: brightness(115%);
    }

    //.svg {
    //  color: $beerenrot;
    //  fill: $beerenrot;
    //}
  }

  .img {
    transition: all 0.4s ease;
    height: 190px;
    background-position: center center;
    /*background-position: 0 50%; //focused corner is bottom center*/
    background-repeat: no-repeat;
    background-size: cover;
    /*background-image: url('../assets/bg2.jpg');*/
    &.isKiosk {
      height: 0;
      padding-bottom: calc(100% * ($imgHeight / $imgWidth)); /* Replace image-height and image-width with the actual values */
    }
  }
}

.bottom {
  padding: 15px 15px 15px 15px;

  &.center {
    text-align: center;
  }
}

/*    position: absolute;*/
/*    bottom: 0;*/
/*    left: 0;*/
/*    padding: 8px 1.5vw;*/
/*    width: 100%;*/
/*    !*background-color: white;*!*/
/*    //background-color: rgba($color-darkblue,0.6);*/
/*    color: white;*/

/*    background-color: black;*/

/*    //@include box-gradient;*/

/*    //background-image: linear-gradient(180deg, rgba(black, 0) 0, rgba(black, 0.6) 60%, rgba(black, 0.8) 100%);*/
/*    //background-image: linear-gradient(180deg, rgba($color-darkblue, 0) 0, rgba($color-darkblue, 0.6) 60%, rgba($color-darkblue, 0.9) 100%);*/
/*    //background-image: linear-gradient(270deg,rgba($color-darkblue,0.02) 0%,$color-darkblue 60%);*/
/*    !*background-image: linear-gradient(top,rgba(255,255,255,0.02) 0%,#BBBBBB 60%);*!*/

/*    .h{*/
/*}*/

/*    !*.s{*!*/
/*    !*    font-size: 0.9em;*!*/
/*    !*    overflow: hidden;*!*/
/*    !*}*!*/

/*}*/
</style>
